import React, { useState } from "react";
import { Box, Button, Container, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../api/auth";
import { useSnack } from "../services/SnakbarProvider";
import { handleError } from "../services/errorHandler";

const validationSchema = Yup.object({
  newPassword: Yup.string()
    .min(8, "La contraseña debe tener al menos 8 caracteres")
    .required("La contraseña es requerida"),
});

export default function ResetPasswordPage() {
  const { openSnack } = useSnack();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const token = searchParams.get("token") || "";
  const [error, setError] = useState("");

  const formik = useFormik({
    initialValues: { newPassword: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      if (!email || !token) {
        setError("Faltan parámetros de recuperación de contraseña.");
        setSubmitting(false);
        return;
      }
      try {
        await resetPassword({ email, token, newPassword: values.newPassword });
        openSnack("Contraseña actualizada exitosamente", "success");
        navigate("/login");
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  if (!email || !token) {
    return (
      <Container maxWidth="xs" sx={{ mt: 10 }}>
        <Paper sx={{ p: 4 }}>
          <Typography color="error">
            Faltan parámetros de recuperación de contraseña. Por favor revisa el enlace enviado a tu correo.
          </Typography>
          <Button fullWidth variant="text" onClick={() => navigate("/login")} sx={{ mt: 2 }}>
            Volver al inicio de sesión
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4 }}>
        <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
          Reestablecer contraseña
        </Typography>
        {error && (
          <Typography color="error" sx={{ mb: 1 }}>
            {error}
          </Typography>
        )}
        <Box component="form" onSubmit={formik.handleSubmit}>
          <TextField
            required
            fullWidth
            margin="normal"
            id="newPassword"
            name="newPassword"
            label="Nueva Contraseña"
            type="password"
            autoComplete="new-password"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
            helperText={formik.touched.newPassword && formik.errors.newPassword}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={formik.isSubmitting}
            sx={{ mt: 3 }}
          >
            Actualizar Contraseña
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
